var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-end border border-2 fixed-top-right px-3 mb-4",class:(this.white) ?'bg-white' :'bg-dark'},[_vm._v(" "+_vm._s(_vm.formattedTime)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }